import { NgModule } from '@angular/core';
import { PoiWidgetComponent } from './poi-widget.component';
import { SwitchModule } from '../../../components/forms/switch/switch.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    SwitchModule
  ],
  declarations: [
    PoiWidgetComponent
  ],
  exports: [
    PoiWidgetComponent
  ]
})
export class PoiWidgetModule { }
